import { useEffect } from 'react';
import apis from './apis';
import useRequest from '../../utils/request';
import useStore from './store';

export default (function ({ manual }) {
  let params = apis.getDevList;
  if (manual) params.manual = true;

  const [, dispatch] = useStore();
  const { data, exec } = useRequest(params);

  useEffect(() => {
    if (data !== null) dispatch.setDevList(data);
  }, [data, dispatch]);

  return [data || [], exec, params.url];
});
